import attributes from '../constants/attributes';
import fieldNames from '../constants/field-names';
import getIframeOuterHtml from './get-iframe-outer-html';
import getInitialIframeEmbeddingType from './get-initial-iframe-embedding-type';

function getIframeDefaultFieldValues(wsIframeElement) {
  const embeddingType = getInitialIframeEmbeddingType(wsIframeElement);
  const url = wsIframeElement?.getAttribute('src') ?? '';
  const allowFullscreen = wsIframeElement?.hasAttribute(attributes.ALLOW_FULLSCREEN) ?? false;
  const code = getIframeOuterHtml(wsIframeElement);

  return {
    embeddingType,
    [fieldNames.IFRAME_URL]: url,
    [fieldNames.IFRAME_ALLOW_FULLSCREEN]: allowFullscreen,
    [fieldNames.IFRAME_CODE]: code,
  };
}

export default getIframeDefaultFieldValues;
